// extracted by mini-css-extract-plugin
module.exports = {"screenReaderText":"Sidebar_screenReaderText__hfRGm","sidebar":"Sidebar_sidebar__2sVY5","navSectionLabel":"Sidebar_navSectionLabel__2YZ4k"};